import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInView } from '../hooks/useInView';

export default function About() {
  const [ref, inView] = useInView();
  const { t } = useTranslation();
  const paragraphs = t('about.paragraphs', { returnObjects: true });
  const education = t('about.education', { returnObjects: true });
  const certifications = t('about.certifications', { returnObjects: true });

  return (
    <section id="about" className={`section about${inView ? ' in-view' : ''}`} ref={ref}>
      <div className="section__container">
        <h2 className="section__title">{t('about.title')}</h2>
        <div className="about__body">
          <div className="about__text">
            {paragraphs.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
          <div className="about__sidebar">
            <div className="about__education">
              <h3 className="about__edu-title">{t('about.educationTitle')}</h3>
              <ul className="about__edu-list">
                {education.map((edu, i) => (
                  <li key={i}>
                    <span className="about__edu-degree">{edu.degree}</span>
                    <span className="about__edu-school">{edu.school}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="about__education">
              <h3 className="about__edu-title">{t('about.certificationsTitle')}</h3>
              <ul className="about__edu-list">
                {certifications.map((cert, i) => (
                  <li key={i}>
                    <span className="about__edu-degree">
                      {cert.url ? (
                        <a href={cert.url} target="_blank" rel="noopener noreferrer">
                          {cert.degree}
                        </a>
                      ) : (
                        cert.degree
                      )}
                    </span>
                    <span className="about__edu-school">{cert.school}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
